import * as React from 'react';

import styles from './FeedbackModalAlert.css';

export class FeedbackModalAlert extends React.Component {
  public render() {
    return (
      <div className={styles['modal-container']}>
        <div className={styles['modal-content_area']}>
          <span className={styles['house-icon']} />
          <div className={styles['text-container']}>
            <p className={styles['thanks-text']}>Спасибо за заявку!</p>
            <p className={styles['alert-text']}>Мы свяжемся с вами в ближайшее время</p>
          </div>
        </div>
      </div>
    );
  }
}
